import cn from 'clsx';
import type { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

const clsx = (...inputs: ClassValue[]) => twMerge(cn(inputs));

export default clsx;
